import { Box, Button, Grid, Icon, Paper, Typography } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { LinearProgress } from "@mui/material";
import { FormHandles } from "@unform/core";
import * as yup from 'yup';

import { AlertSnackBar, AutoCompleteDeUnidade, FerramentaDeDetalhe } from "../../shared/components";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { VTextField, VForm, useVForm } from "../../shared/forms";
import { SetorService, ISetor } from "../../shared/services/api/setor/SetorService";
import { Environment } from "../../shared/environment";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";

interface IFormData {
    idSetor: number,
    nomeSetor: string,
    idUnidade: number
}
interface IFormDataValidation {
    nomeSetor: string,
}

const formValidationSchema: yup.SchemaOf<IFormDataValidation> = yup.object().shape({
    nomeSetor: yup.string().required("O nome do setor é obrigatório"),
});

export const DetalheDeSetor: React.FC = () => {
    const { idSetor = 'novo' } = useParams<'idSetor'>();
    const navigate = useNavigate();

    const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();


    const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const [isLoading, setIsLoading] = useState(false);
    const [titulo, setTitulo] = useState('');
    const [idUnidade, setIdUnidade] = useState<number | undefined>(undefined);
    useEffect(() => { setIdUnidade(Number(localStorage.getItem("idUnidade"))) }, [])

    useEffect(() => {
        if ((localStorage.getItem("cnpj") === "" || localStorage.getItem("cnpj") === null || localStorage.getItem("cnpj") === undefined)
            || (localStorage.getItem("idUnidade") === "" || localStorage.getItem("idUnidade") === null || localStorage.getItem("idUnidade") === undefined)) {
            navigate('/setor');
        } else {
            setIdUnidade(Number(localStorage.getItem("idUnidade")));
        }
    }, [localStorage.getItem("cnpj"), localStorage.getItem("idUnidade")])

    useEffect(() => {
        if (idSetor !== 'novo') {
            setIsLoading(true);
            setTitulo("Carregando...")

            SetorService.getByIdSetor(Number(idSetor))
                .then((result) => {
                    setIsLoading(false);
                    if (result instanceof Error) {
                        // se der erro, volta para a listagem para não ficar uma tela em branco
                        setAlert({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlert(undefined);
                        }, duracaoAlert);
                        // alert(result.message);
                        navigate('/setor');
                    } else {
                        setTitulo(result.nomeSetor);
                        formRef.current?.setData(result);

                    }
                });
        } else {
            limparCampos();
        }
    }, [idSetor])

    const handleSave = (dados: IFormData) => {
        if (idSetor === 'novo') {
            if (idUnidade === undefined || idUnidade === null || idUnidade === 0) {
                setAlert({ tipoAlert: "erro", mensagem: "Selecione um cliente e uma área" });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            }
        }
        formValidationSchema.validate(dados, { abortEarly: false }).then(() => {
            if (idSetor === 'novo') {
                if (idUnidade !== undefined && idUnidade !== null && idUnidade !== 0) {
                    setIsLoading(true);
                    dados.idUnidade = idUnidade;

                    SetorService.create(dados).then((result) => {
                        setIsLoading(false);
                        if (result instanceof Error) {
                            setAlert({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlert(undefined);
                            }, duracaoAlert);
                        } else {
                            setAlert({ tipoAlert: "sucesso", mensagem: "Setor cadastrado" });
                            setTimeout(() => {
                                setAlert(undefined);
                            }, duracaoAlert);

                            if (isSaveAndReturn()) {
                                navigate(-1)
                            } else {
                                limparCampos();
                            }
                        }
                    });
                }
            } else {

                if (dados.nomeSetor == titulo) {
                    setAlert({ tipoAlert: "erro", mensagem: "O nome não foi alterado" });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                } else {
                    setIsLoading(true);
                    dados.idSetor = Number(idSetor);

                    SetorService.updateById(dados)
                        .then((result) => {
                            setIsLoading(false);
                            if (result instanceof Error) {
                                setAlert({ tipoAlert: "erro", mensagem: result.message });
                                setTimeout(() => {
                                    setAlert(undefined);
                                }, duracaoAlert);
                            } else {
                                setTitulo(dados.nomeSetor);
                                setAlert({ tipoAlert: "sucesso", mensagem: "Setor atualizado" });
                                setTimeout(() => {
                                    setAlert(undefined);
                                }, duracaoAlert);

                                if (isSaveAndReturn()) {
                                    navigate(-1)
                                }
                            }
                        });
                }
            }
        }).catch((errors: yup.ValidationError) => {
            const validationErrors: { [key: string]: string } = {};

            errors.inner.forEach(error => {
                if (!error.path) return;
                validationErrors[error.path] = error.message;
            });

            formRef.current?.setErrors(validationErrors);
        });

    }

    const limparCampos = () => {
        formRef.current?.setData({
            nomeSetor: ''
        });
    }

    const handleDelete = () => {
        SetorService.toggleEstadoById(Number(idSetor))
            .then(result => {
                if (result instanceof Error) {//verificar se deu erro
                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                } else {
                    setAlert({ tipoAlert: "erro", mensagem: "Setor desativado com sucesso" });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                    navigate('/setor');
                }
            });
    }

    const [abrir, setAbrir] = useState(false);

    const handleCancel = () => {
        setAbrir(false);
    };

    return (

        <LayoutBaseDePagina
            titulo={idSetor === 'novo' ? 'Novo setor' : titulo}
            barraDeFerramentas={
                <FerramentaDeDetalhe
                    mostrarBotaoSalvarEVoltar
                    mostrarBotaoApagar={idSetor !== 'novo'}
                    mostrarBotaoNovo={idSetor !== 'novo'}

                    mostrarBotaoNovoCarregando={isLoading}
                    mostrarBotaoApagarCarregando={isLoading}
                    mostrarBotaoSalvarCarregando={isLoading}
                    mostrarBotaoSalvarEVoltarCarregando={isLoading}

                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEVoltar={saveAndReturn}
                    aoClicarEmApagar={() => setAbrir(true)}
                    aoClicarEmNovo={() => navigate('/setor/detalhe/novo')}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            {alert !== undefined && (
                <>
                    {alert.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            <DialogConfirm
                AoConfirmar={handleDelete}
                titulo={"Dejesa realmente desativar o setor?"}
                texto={"Ao confirmar, o setor e tudo que está contido nele será desativado, para defazer a ação será necessário reativar-lo na listagem de setores desativado."}
                abrir={abrir}
                AoCancelar={handleCancel}
            />


            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}
            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">

                <VForm ref={formRef} onSubmit={handleSave}>
                    <Grid container direction="column" padding={2} spacing={2}>

                        <Grid container item direction="row" spacing={2}>

                            <Grid container item direction="row" spacing={2}>

                                <Grid item xs={12} sm={12} md={4}>
                                    <VTextField fullWidth label="Nome" placeholder="Digite o nome..." name="nomeSetor" />
                                </Grid>

                            </Grid>

                        </Grid>

                    </Grid>
                </VForm>

            </Box>

        </LayoutBaseDePagina>
    )
}
